import React from 'react'
import { HeaderSeparator } from '../../components'

import styles from './styles.module.css'

const WelcomePage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.separatorContainer}>
        <HeaderSeparator />
        <p className={styles.textName}>Александр & Мария</p>
        <HeaderSeparator />
      </div>
      <p className={styles.invitationText}>
      Мы собираемся пожениться, и мы хотим чтобы Вы <br /> были частью нашего особенного дня
      </p>
      <p className={styles.invitationDate}>Среда, 10 Сентября 2025, 15:30</p>
      {/* <div className={styles.buttonContainer}>
        <Button text="Save the Date!" />
      </div> */}
    </div>
  )
}

export default WelcomePage
